import React from 'react';

import NormalImg from '../common/Img';
import styled from 'styled-components';

const Img = styled(NormalImg)`
  width: 50px;
  margin: 10px auto 10px auto;
  display: block;
`;

// TODO: handle text string.

class ExaminerTextBlock extends React.Component {
    render() {

        //console.log(this.props);
        return (
            <div className={this.props.boxmode}>
                <div className="panel-body">
                <Img src={this.props.boxicon} alt="Mic Icon" /> 
                {this.props.children}
                </div>
            </div>
        );
    }
}

export default ExaminerTextBlock;


// WEBPACK FOOTER //
// ./src/components/exam/ExaminerTextBlock.js